import React, { useState, useEffect, useMemo } from 'react';
import api from '../api';
import { ListSkeleton } from '../components/ui';

const DIRFLAG = {
  'Italia':'🇮🇹','DACH':'🇩🇪','Francia':'🇫🇷','Spagna':'🇪🇸',
  'Benelux':'🇳🇱','Est Europa':'🇨🇿','ITA':'🇮🇹','DEU':'🇩🇪','FRA':'🇫🇷',
  'ESP':'🇪🇸','NLD':'🇳🇱','CEE':'🇨🇿','BEL':'🇧🇪','UK':'🇬🇧',
};

const LVL_COLOR = {
  'MASSIMO':'var(--cyan)','MOLTO ALTO':'var(--purple)','ALTO':'var(--yellow)',
  'Alto':'var(--yellow)','Medio-Alto':'var(--text-muted)','Medio':'var(--text-muted)',
};

const ST_BADGE = {
  IN_LISTA:   { bg:'var(--surface)',  color:'var(--text-muted)', label:'In lista' },
  nuovo:      { bg:'var(--surface)',  color:'var(--text-muted)', label:'Nuovo' },
  contattato: { bg:'rgba(0,212,255,0.12)', color:'var(--cyan)',  label:'Contattato' },
  in_trattativa:{ bg:'rgba(255,200,0,0.12)', color:'var(--yellow)', label:'In trattativa' },
  won:        { bg:'rgba(0,255,136,0.12)', color:'var(--green)', label:'Firmato ✓' },
  lost:       { bg:'rgba(255,80,80,0.12)', color:'var(--red)',   label:'Perso' },
};

function LeadTable({ leads }) {
  return (
    <div style={{ overflowX:'auto', marginTop:6 }}>
      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
        <thead>
          <tr style={{ background:'var(--bg3)', color:'var(--text-muted)', textAlign:'left' }}>
            {['Azienda','Città','Zona','Rating','Prestigio','Fatturato','Stato'].map(h => (
              <th key={h} style={{ padding:'8px 12px', fontWeight:600, whiteSpace:'nowrap', borderBottom:'1px solid var(--border)' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {leads.map(l => {
            const lvlColor = LVL_COLOR[l.livello] || 'var(--text-muted)';
            const sb = ST_BADGE[l.stato] || ST_BADGE.nuovo;
            return (
              <tr key={l.id} style={{ borderBottom:'1px solid var(--border)' }}>
                <td style={{ padding:'9px 12px', fontWeight:600, color:'var(--text)' }}>{l.azienda || '—'}</td>
                <td style={{ padding:'9px 12px', color:'var(--text-muted)' }}>{l.citta || '—'}</td>
                <td style={{ padding:'9px 12px', color:'var(--text-muted)', fontSize:11.5 }}>{l.zona || '—'}</td>
                <td style={{ padding:'9px 12px', color:'var(--text-muted)' }}>{l.rating_val ? `★ ${l.rating_val}` : '—'}</td>
                <td style={{ padding:'9px 12px', color:lvlColor, fontWeight:600, fontSize:11.5 }}>{l.livello || '—'}</td>
                <td style={{ padding:'9px 12px', color:'var(--text-muted)', fontSize:11.5 }}>{l.fatturato || '—'}</td>
                <td style={{ padding:'9px 12px' }}>
                  <span style={{ fontSize:11, padding:'2px 8px', borderRadius:20, background:sb.bg, color:sb.color, whiteSpace:'nowrap' }}>
                    {sb.label}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function DirAccordion({ direttore, leads, isOpen, onToggle }) {
  const won = leads.filter(l => l.stato === 'won').length;
  const attivi = leads.filter(l => l.stato === 'in_trattativa').length;
  const flag = DIRFLAG[direttore.area] || '💼';

  return (
    <div style={{ border:'1px solid var(--border)', borderRadius:9, overflow:'hidden', marginBottom:7 }}>
      <div
        onClick={onToggle}
        style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'11px 13px', background:'var(--surface)', cursor:'pointer' }}
        onMouseEnter={e => e.currentTarget.style.background='var(--surface-h)'}
        onMouseLeave={e => e.currentTarget.style.background='var(--surface)'}
      >
        <span style={{ fontWeight:600, fontSize:12.5, color:'var(--text)' }}>
          {flag} {direttore.name} · {direttore.area}
        </span>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ color:'var(--text-muted)', fontSize:11.5 }}>{leads.length} lead ▾</span>
          {attivi > 0 && <span style={{ fontSize:11, padding:'2px 7px', borderRadius:20, background:'rgba(255,200,0,0.12)', color:'var(--yellow)' }}>{attivi} attivi</span>}
          {won > 0 && <span style={{ fontSize:11, padding:'2px 7px', borderRadius:20, background:'rgba(0,255,136,0.12)', color:'var(--green)' }}>{won} firmati</span>}
          <span style={{ color:'var(--text-dim)', fontSize:12 }}>{isOpen ? '▲' : '▾'}</span>
        </div>
      </div>
      {isOpen && (
        <div style={{ background:'var(--bg)', padding:'0 13px 11px' }}>
          {leads.length > 0
            ? <LeadTable leads={leads} />
            : <p style={{ color:'var(--text-muted)', fontSize:12, padding:'6px 0' }}>nessun lead per questo cliente</p>
          }
        </div>
      )}
    </div>
  );
}

// ── DETTAGLIO CLIENTE B2B ─────────────────────────────────────────────────────
function ClienteDetail({ cliente, onBack }) {
  const [leads, setLeads] = useState([]);
  const [openDir, setOpenDir] = useState(null);

  useEffect(() => {
    api.get(`/leads/by_cliente/${cliente.id}`)
      .then(r => setLeads(Array.isArray(r.data) ? r.data : []))
      .catch(() => setLeads([]));
  }, [cliente.id]);

  // Raggruppa leads per direttore, mantieni ordine
  const dirs = useMemo(() => {
    const map = new Map();
    for (const l of leads) {
      if (!l.direttore) continue;
      if (!map.has(l.direttore)) map.set(l.direttore, { name: l.direttore, area: '', leads: [] });
      map.get(l.direttore).leads.push(l);
    }
    return Array.from(map.values());
  }, [leads]);

  const piano = cliente.b2b_piano || [];
  const regole = cliente.b2b_regole || [];

  return (
    <div style={{ padding:'clamp(16px, 4vw, 28px) clamp(16px, 4vw, 32px)', maxWidth:1200, margin:'0 auto' }}>
      <p style={{ fontSize:12.5, color:'var(--text-muted)', margin:'0 0 18px' }}>
        <span style={{ color:'var(--cyan)', cursor:'pointer' }} onClick={onBack}>← B2B Distribution</span>
        {' · '}
        <b style={{ color:'var(--text)' }}>{cliente.azienda || cliente.nome}</b>
      </p>

      <h1 style={{ fontSize:22, fontWeight:700, color:'var(--text)', margin:'0 0 4px' }}>{cliente.azienda || cliente.nome} · B2B</h1>
      <p style={{ fontSize:13, color:'var(--text-muted)', margin:'0 0 20px' }}>
        Servizio vendite B2B → {cliente.azienda || cliente.nome} · {leads.length} lead su {dirs.length} direttori
      </p>

      {(piano.length > 0 || regole.length > 0) && (
        <div className="form-grid-2" style={{ marginBottom:20 }}>
          {piano.length > 0 && (
            <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:12, padding:'14px 16px' }}>
              <div style={{ fontWeight:700, fontSize:12.5, marginBottom:8, color:'var(--text)' }}>🗺️ Piano di espansione</div>
              <ul style={{ margin:0, paddingLeft:18, fontSize:12, lineHeight:1.7, color:'var(--text-muted)' }}>
                {piano.map((p,i) => <li key={i}>{p}</li>)}
              </ul>
            </div>
          )}
          {regole.length > 0 && (
            <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:12, padding:'14px 16px' }}>
              <div style={{ fontWeight:700, fontSize:12.5, marginBottom:8, color:'var(--text)' }}>⚖️ Regole B2B</div>
              <ul style={{ margin:0, paddingLeft:18, fontSize:12, lineHeight:1.7, color:'var(--text-muted)' }}>
                {regole.map((r,i) => <li key={i}>{r}</li>)}
              </ul>
            </div>
          )}
        </div>
      )}

      <p style={{ fontSize:11, fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:10 }}>
        Lead per direttore — filtrati: {cliente.azienda || cliente.nome}
      </p>

      {dirs.length === 0
        ? <p style={{ color:'var(--text-muted)', fontSize:13, padding:20 }}>Nessun lead per questo cliente.</p>
        : dirs.map(dir => (
            <DirAccordion
              key={dir.name}
              direttore={dir}
              leads={dir.leads}
              isOpen={openDir === dir.name}
              onToggle={() => setOpenDir(openDir === dir.name ? null : dir.name)}
            />
          ))
      }
    </div>
  );
}

// ── LANDING ───────────────────────────────────────────────────────────────────
export default function B2BDistribution() {
  const [clientiB2B, setClientiB2B] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/leads/b2b_clienti')
      .then(r => { setClientiB2B(Array.isArray(r.data) ? r.data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <ListSkeleton rows={5} />;

  if (selected) {
    return <ClienteDetail cliente={selected} onBack={() => setSelected(null)} />;
  }

  return (
    <div className="eden-page">
      <h1 style={{ fontSize:22, fontWeight:700, margin:'0 0 4px', color:'var(--text)' }}>B2B Distribution</h1>
      <p style={{ fontSize:13, color:'var(--text-muted)', margin:'0 0 22px' }}>
        Clienti attivi del servizio vendite B2B
      </p>

      {clientiB2B.length === 0
        ? <p style={{ color:'var(--text-dim)', textAlign:'center', padding:60 }}>Nessun cliente B2B configurato.</p>
        : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px,1fr))', gap:14 }}>
            {clientiB2B.map(c => (
              <div key={c.id}
                onClick={() => setSelected(c)}
                style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:14, padding:'20px 22px', cursor:'pointer', transition:'border-color 0.15s, background 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='rgba(0,212,255,0.4)'; e.currentTarget.style.background='var(--surface-h)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.background='var(--surface)'; }}
              >
                <div style={{ fontWeight:700, fontSize:15, color:'var(--text)', marginBottom:4 }}>
                  💎 {c.azienda || c.nome}
                </div>
                <div style={{ fontSize:12, color:'var(--text-muted)', marginBottom:14 }}>
                  servizio B2B attivo · {c.n_leads || 0} lead su {c.n_direttori || 0} direttori
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                  <div style={{ background:'var(--bg3)', borderRadius:8, padding:'8px 12px' }}>
                    <div style={{ fontSize:16, fontWeight:700, color:'var(--cyan)' }}>{(c.b2b_piano||[]).length}</div>
                    <div style={{ fontSize:10.5, color:'var(--text-muted)' }}>piani espansione</div>
                  </div>
                  <div style={{ background:'var(--bg3)', borderRadius:8, padding:'8px 12px' }}>
                    <div style={{ fontSize:16, fontWeight:700, color:'var(--purple)' }}>{(c.b2b_regole||[]).length}</div>
                    <div style={{ fontSize:10.5, color:'var(--text-muted)' }}>regole B2B</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      }
      <p style={{ fontSize:12, color:'var(--text-dim)', marginTop:20 }}>
        Altri clienti del servizio B2B compariranno qui come sotto-sezioni.
      </p>
    </div>
  );
}
